var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('solid-primary-button',_vm._g(_vm._b({attrs:{"text":_vm.text,"color":_vm.btnColor}},'solid-primary-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$t('submit'))+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }